import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { GridApi, GridOptions } from 'ag-grid';

import { Regla } from '../Models/Regla';

import { ReglaService } from '../services/regla.service';
import { GlobalsService } from '../services/globals.service';

@Component({
  selector: 'app-reglas',
  templateUrl: './reglas.component.html',
  styleUrls: ['./reglas.component.css']
})
export class ReglasComponent implements OnInit {


  public regla: Regla = new Regla();
  public reglas: Regla[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;


  @ViewChild('agGrid') agGrid: AgGridNg2;
  title = 'reglas';

  columnDefs = [
    { headerName: 'Nombre', field: 'idRegla', icons: { filter: ' ' } },
    { headerName: 'Descripción', field: 'descripcion', icons: { filter: ' ' } },
    { headerName: 'Tipo Regla', field: 'tipoRegla', icons: { filter: ' ' } },
    { headerName: 'Alfanumerico', field: 'valorAlfanumerico', icons: { filter: ' ' } },
    { headerName: 'Numerico', field: 'valorNumerico', icons: { filter: ' ' } },
    { headerName: 'Logico', field: 'valorLogico', icons: { filter: ' ' } },
    { headerName: 'Estado', field: 'estado', icons: { filter: ' ' } }

  ];

  rowData: any[];

  constructor(private reglaService: ReglaService, private globalServices: GlobalsService) {
  }
  ngOnInit() {
    this.CargarReglas();
    // this.regla.tipoRegla="Alfanumerico";
  }



  CargarReglas() {
    try {

      this.reglaService.ObtenerReglas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.reglas = data;
          //grid
          this.reglas.forEach(element => {
            if (element.tipoRegla === "Alfanumerico") {
              element.valorNumerico = undefined;
              element.valorLogico = undefined;
            }

            if (element.tipoRegla === "Numerico") {
              element.valorAlfanumerico = undefined;
              element.valorLogico = undefined;
            }
            if (element.tipoRegla === "Logico") {
              element.valorAlfanumerico = undefined;
              element.valorNumerico = undefined;
            }

          });
          this.rowData = this.reglas;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReglas: " + error);
    }
  }

  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.regla = new Regla();
    this.modoEdicion = true;
    this.regla.tipoRegla = "Alfanumerico";
    this.regla.estado = "Activo";
  }
  CancelarEdicion() {
    this.regla = new Regla();
    this.modoEdicion = false;
  }

  //click en el row de la tabla
  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    this.nuevoRegistro = false;
    this.regla = datos;
    this.modoEdicion = true;

  }



  //Inserta o actualiza el vehiculo
  GuardarRegistro() {

    this.regla.idcompania = this.globalServices.ObtenerCompania();

    this.reglaService.GuardarRegistro(this.regla).subscribe(

      data => {

        swal("Registro guardado con éxito!", "", "success");

        this.regla = new Regla();
        this.modoEdicion = false;

        this.CargarReglas();

      },
      err => {
        console.log("GuardarRegistro: " + err);
      }

    );


  }


}
